import React, { useEffect, useState } from "react";
import "./Summary.css";
import useFullPageLoader from "common/UseFullPageLoader";
import { growthTrackingListApi } from "services/growthTracking";
import { firstWordCapital, formatRelativeDate } from "utils/common";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";


const Summary = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [duration, setDuration] = useState("DAY");
  const [measurement, setMeasurement] = useState([]);

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await growthTrackingListApi({ childId: _child, duration, type: "SUMMARY", limit: 5000 });
      if (status === 200) {
        setMeasurement(data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, [duration]);

  const stringy = (value) => {
    if (value) {
      return value;
    } else if (value === 0) {
      return "0"
    }

    return false
  }


  return (
    <>
      <div className="table_parent">
        <div className="frame">
          <div className="title">Frame</div>
          <div className="full-history">Full history</div>
          <div class="tabs">
            <div class={`tab ${duration === "DAY" ? "active" : ""}`} onClick={() => setDuration("DAY")}>Day</div>
            <div class={`tab ${duration === "WEEK" ? "active" : ""}`} onClick={() => setDuration("WEEK")}>Week</div>
            <div class={`tab ${duration === "MONTH" ? "active" : ""}`} onClick={() => setDuration("MONTH")}>Months</div>
          </div>

          {
            duration === "DAY"
              ?
              <table className="history-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Week</th>
                    <th>Weight(Kg)</th>
                    <th>Height(Cm)</th>
                    <th>Head</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    measurement[0]?.createdAt &&
                    measurement.map(ele => (
                      <tr key={ele?._id}>
                        <td className="date">{formatRelativeDate(moment(ele?._id, "YYYY-MM-DD").format("DD-MM-YYYY"))}</td>
                        <td className="week">{ele?.week}</td>
                        <td className="weight">{ele?.weight?.length ? ele?.weight[0]?.value : "---"}</td>
                        <td className="weight">{ele?.height?.length ? ele?.height[0]?.value : "---"}</td>
                        <td className="weight">{ele?.head?.length ? ele?.head[0]?.value : "---"}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
              :
              <div className=" col-sm-12">
                <div className="motorskilltracking_lft">
                  <Accordion className="outer_accordian">
                    {
                      measurement.map((measurementDetail, i) => (
                        <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>{
                            stringy(measurementDetail?._id?.week) || stringy(measurementDetail?._id?.month)
                          } {firstWordCapital(duration.toLowerCase())}</Accordion.Header>

                          <Accordion.Body>
                            <Accordion className="inner_accordian">
                              {
                                measurementDetail?.documents?.map((ele, j) => (
                                  <Accordion.Item eventKey={j} key={j}>
                                    <Accordion.Header>
                                      <div className="accordian_parent">
                                        <div className="accordian_child">
                                          <ul>
                                            <li>{formatRelativeDate(moment(ele?.date, "YYYY-MM-DD").format("DD-MM-YYYY"))}</li>
                                            <td className="weight">{ele?.weight?.length ? ele?.weight[0]?.value : "---"}</td>
                                            <td className="weight">{ele?.height?.length ? ele?.height[0]?.value : "---"}</td>
                                            <td className="weight">{ele?.head?.length ? ele?.head[0]?.value : "---"}</td>
                                          </ul>
                                        </div>
                                      </div>
                                    </Accordion.Header>
                                  </Accordion.Item>
                                ))
                              }
                            </Accordion>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))
                    }
                  </Accordion>
                </div>
              </div>
          }


        </div>
      </div>
    </>
  );
};

export default Summary;
